import axiosInstance from '../axios'
import { quoteFormToAutofillQuotationPatch } from './materialsQuotationAutofillDraftService.ts'

const getAuthHeaders = () => {
  const authToken = localStorage.getItem('access-Token-Edify')
  return { headers: { Authorization: `Bearer ${authToken}` } }
}

export type PublishQuotationFormInput = {
  name: string
  city: string
  receiveFrom: string
  receiveTo: string
  currency: string
  description: string
  jurisdiccion: string | number | null
  delivery: boolean
  latitude?: number | null
  longitude?: number | null
}

export type PublishMaterialInput = {
  id: number | string
  name: string
  unit: string
  quantity: number
  temporary?: boolean
  categoryId?: number | string
  category_id?: number | string
}

export type PublishMaterialPayload = {
  category_id: number
  material_id: number | string
  temporary: boolean
  amount: number
  name: string
  unit: string
}

export function quoteFormToPublishQuotationBody(quoteData: PublishQuotationFormInput): Record<string, unknown> {
  const juris =
    quoteData.jurisdiccion != null && quoteData.jurisdiccion !== ''
      ? String(quoteData.jurisdiccion)
      : ''
  return {
    ...quoteFormToAutofillQuotationPatch({
      name: quoteData.name,
      city: quoteData.city,
      receiveFrom: quoteData.receiveFrom,
      receiveTo: quoteData.receiveTo,
      currency: quoteData.currency,
      description: quoteData.description,
      jurisdiccion: juris,
      delivery: quoteData.delivery === true,
      latitude: quoteData.latitude,
      longitude: quoteData.longitude,
    }),
    active: 1,
    type: 'PRIVATE',
  }
}

export function selectedMaterialsToPublishPayload(materials: PublishMaterialInput[]): PublishMaterialPayload[] {
  if (!Array.isArray(materials)) {
    return []
  }
  return materials.map((material) => {
    const cid =
      material.categoryId != null && material.categoryId !== ''
        ? Number(material.categoryId)
        : material.category_id != null && material.category_id !== ''
          ? Number(material.category_id)
          : 0
    return {
      category_id: Number.isFinite(cid) ? cid : 0,
      material_id: material.id,
      temporary: material.temporary === true,
      amount: material.quantity,
      name: material.name,
      unit: material.unit,
    }
  })
}

export async function publishMaterialsQuotation(
  quotation: Record<string, unknown>,
  materials: PublishMaterialPayload[]
): Promise<unknown> {
  const response = await axiosInstance.post(
    '/sub_quotation/materials/publish',
    { quotation, materials },
    getAuthHeaders()
  )
  return response.data
}

export function parseMaterialsQuotationPublishResponse(raw: unknown): string | null {
  if (!raw || typeof raw !== 'object') return null
  const r = raw as Record<string, unknown>
  const data = r.data && typeof r.data === 'object' ? (r.data as Record<string, unknown>) : r
  const id = data.quotationId ?? data.id ?? data.quotation_id
  if (id == null) return null
  const s = String(id).trim()
  return s.length ? s : null
}
